import * as Analytics from 'analytics/analytics'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { useCallback } from 'react'
import {
  SearchContext_1_0_1,
  Filter_1_0_0,
  Sort_1_0_0,
  Search_3_0_0,
} from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

export function useSearchAnalytics({
  searchEvent,
  searchContext,
  filterContexts = [],
  sortContext = { value: 'recommended' },
}: {
  searchEvent?: Search_3_0_0,
  searchContext?: SearchContext_1_0_1
  filterContexts?: Array<Filter_1_0_0>
  sortContext?: Sort_1_0_0
}) {
  const trackSearchEvent = useCallback(() => {
    if (searchEvent && searchContext) { Analytics.trackEvent(searchEventWithContext({
      searchEvent,
      searchContext,
      filterContexts,
      sortContext,
    })) }
  }, [searchEvent, searchContext, filterContexts, sortContext])

  return {
    trackSearchEvent,
  }
}

export default useSearchAnalytics
